import { NgModule, inject, provideAppInitializer } from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ExtraOptions, PreloadAllModules, RouterModule} from '@angular/router';
import {FuseModule} from '@fuse';
import {FuseConfigModule} from '@fuse/services/config';
import {CoreModule} from 'app/core/core.module';
import {appConfig} from 'app/core/config/app.config';
import {LayoutModule} from 'app/layout/layout.module';
import {AppComponent} from 'app/app.component';
import {appRoutes} from 'app/app.routing';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {MatPaginatorI18n} from './shared/mat-paginator-i18n/mat-paginator-i18n';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {RefreshTokenInterceptor} from './shared/interceptors/refresh-token.interceptor';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {environment} from '../environments/environment';
import {ApiModule, Configuration} from '../api-clients/generated/services';
import {ApiModule as PraticheApiModule, Configuration as PraticheConfiguration} from '../api-clients/gestione-pratiche/services';
import {LocalStorageService} from './shared/services/local-storage.service';
import {ComuneService} from './shared/services/comune.service';
import {CustomDateAdapter} from './shared/services/custom-date-adapter.service';
import { PastiDaPreparareReportComponent } from './modules/landing/pasti-da-preparare-report/pasti-da-preparare-report.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};


@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        MatDatepickerModule,
        MatNativeDateModule,

        ApiModule,

        PraticheApiModule.forRoot(() => new PraticheConfiguration({
            basePath: environment.ticketsBackend.url + '/gestione-pratiche',
        })),

    ],
    providers: [
        MatDatepickerModule,
        ComuneService,
        {provide: MAT_DATE_LOCALE, useValue: 'it'},
        {provide: MatPaginatorIntl, useClass: MatPaginatorI18n},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RefreshTokenInterceptor,
            multi: true,
        },
        provideAppInitializer(() => {
        const initializerFn = ((configService: ComuneService) =>
                () => configService.initApp())(inject(ComuneService));
        return initializerFn();
      }),
        {
            provide: Configuration,
            useFactory: (localStorageService: LocalStorageService) => new Configuration(
                    {
                        basePath: environment.servicesUrl,
                        accessToken: () => localStorageService.getAccessToken()
                    }),
            deps: [LocalStorageService],
            multi: false,
        },
        { provide: DateAdapter, useClass: CustomDateAdapter },
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { subscriptSizing: 'dynamic' }
        }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}


